import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-nursly-forest group-[.toaster]:text-white group-[.toaster]:border-nursly-forest-mid group-[.toaster]:rounded-xl group-[.toaster]:shadow-none group-[.toaster]:font-body",
          description: "group-[.toast]:text-white/70",
          actionButton: "group-[.toast]:bg-nursly-amber group-[.toast]:text-white",
          cancelButton: "group-[.toast]:bg-white/10 group-[.toast]:text-white/80",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
